/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubjectsForGroupDTO
 */
export interface SubjectsForGroupDTO {
    /**
     * 
     * @type {string}
     * @memberof SubjectsForGroupDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SubjectsForGroupDTO
     */
    nameRO?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectsForGroupDTO
     */
    nameEN?: string | null;
}

export function SubjectsForGroupDTOFromJSON(json: any): SubjectsForGroupDTO {
    return SubjectsForGroupDTOFromJSONTyped(json, false);
}

export function SubjectsForGroupDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubjectsForGroupDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'nameRO': !exists(json, 'nameRO') ? undefined : json['nameRO'],
        'nameEN': !exists(json, 'nameEN') ? undefined : json['nameEN'],
    };
}

export function SubjectsForGroupDTOToJSON(value?: SubjectsForGroupDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'nameRO': value.nameRO,
        'nameEN': value.nameEN,
    };
}

